export const SUBMIT_BTN_TEXT = 'Continue';
export const DEFAULT_TYPE = 'submit';
export const SAVING_TEXT = 'Saving...';
